<template>
  <div>
    <div ref="graphContainer" class="w-full h-full">
      <div :id="`container-${chart.Id}`"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import * as d3 from "d3";

// #region Props, Emits
const props = defineProps({
  chart: {
    type: Object,
    required: true,
  },
  orientation: {
    type: String,
    required: true,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const graphContainer = ref(null);
// #endregion

// #region Functions
function loadGraph(id, width, height) {
  // graphContainer width and height
  const margin = 40;

  // Create the container.
  const container = d3.select(id);

  // Create the SVG element.
  const svg = container
    .append("svg")
    .attr("width", width)
    .attr("height", height);

  // Create the scales.
  const x = d3
    .scaleLinear()
    .domain([0, 10])
    .range([margin, width - margin]);

  const y = d3
    .scaleLinear()
    .domain([0, 10])
    .range([height - margin, margin]);

  // Create the axes.
  const xAxis = d3.axisBottom(x);

  const yAxis = d3.axisLeft(y);

  const color = props.chart.propiedades?.barras?.color
    ? props.chart.propiedades.barras.color
    : "lightblue";

  // Create the bars
  if (props.orientation == "vertical") {
    svg
      .selectAll("rect")
      .data([1, 2, 3, 4, 5])
      .enter()
      .append("rect")
      .attr("x", (d) => x(d))
      .attr("y", (d) => y(d))
      .attr("width", width / 10)
      .attr("height", (d) => height - margin - y(d))
      .attr("fill", color);
  } else {
    svg
      .selectAll("rect")
      .data([1, 2, 3, 4, 5])
      .enter()
      .append("rect")
      .attr("x", margin)
      .attr("y", (d) => y(d))
      .attr("width", (d) => x(d) - margin)
      .attr("height", height / 10 - margin / 2)
      .attr("fill", color);
  }

  // Draw the x axis.
  svg
    .append("g")
    .attr("transform", `translate(0, ${height - margin})`)
    .call(xAxis);

  // Draw the y axis.
  svg.append("g").attr("transform", `translate(${margin}, 0)`).call(yAxis);

  const ejes = props.chart.propiedades.ejes;

  // Draw the x axis label.
  svg
    .append("text")
    .attr("x", width / 2)
    .attr("y", height - margin / 4)
    .attr("text-anchor", "middle")
    .attr("font-size", "12px")
    .text(ejes.xAxis);

  // Draw the y axis label.
  svg
    .append("text")
    .attr("transform", "rotate(-90)")
    .attr("x", -height / 2)
    .attr("y", margin / 2)
    .attr("text-anchor", "middle")
    .attr("font-size", "12px")
    .text(ejes.yAxis);
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  graphContainer,
  loadGraph,
});
// #endregion
</script>
